import {
    ORDER_LIST_PAGE_LOADED,
    ORDER_LIST_NEXT_PAGE_LOADED,
    ORDER_LIST_PAGE_FILTER_LOADED,
    ORDER_DETAIL_PAGE_LOADED,
    ORDER_DETAIL_PAGE_UNLOADED,
    CANCEL_ORDER,
    TRADE_PAGE_LOADED,
    TRADE_PAGE_UNLOADED,
    CREATE_TRADE,
    FEES_PAGE_LOADED,
    FEES_PAGE_UNLOADED,
    GET_ESTIMATE_FEE,
    UPDATE_TRADE_AMOUNT_PRICE,
    CANCEL_TO_CREATE_ORDER
} from '../constants/actionTypes';
import { REACT_APP_PAGESIZE } from '../constants/config'

export default (state = {}, action) => {
    switch (action.type) {
        case ORDER_DETAIL_PAGE_UNLOADED:
        case TRADE_PAGE_UNLOADED:
        case FEES_PAGE_UNLOADED:
            return {}
        case TRADE_PAGE_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                fee_rate_buy: action.payload ? action.payload[0] : null,
                fee_rate_sell: action.payload ? action.payload[1] : null,
                accountX: action.payload ? action.payload[2].account : null,
                accountY: action.payload ? action.payload[3].account : null,
            }
        case CREATE_TRADE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                order: action.error ? null : action.payload ? action.payload.order : null,
                codeStatus: action.error ? null : action.payload ? action.payload.code_status : null,
            }
        case ORDER_LIST_PAGE_LOADED:
        case ORDER_LIST_PAGE_FILTER_LOADED:
        case ORDER_LIST_NEXT_PAGE_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                orders: action.payload.orders,
                totalCount: action.payload.totalCount,
                currentPage: action.currentPage,
                totalPage: Math.ceil(action.payload.totalCount / REACT_APP_PAGESIZE)
            }
        case ORDER_DETAIL_PAGE_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                order: action.payload ? action.payload[0].order : null,
                orders: action.payload ? action.payload[1].orders : [],
            }
        case CANCEL_ORDER:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                order_cancel_success: action.error ? null : action.payload ? action.payload.result : null,
            }
        case FEES_PAGE_LOADED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                btc_fee: action.error ? 0 : action.payload[0].fee,
                eth_fee: action.error ? 0 : action.payload[1].fee
            }
        case GET_ESTIMATE_FEE:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                fee: action.error ? 0 : action.payload.fee
            }
        case UPDATE_TRADE_AMOUNT_PRICE:
            return {
                ...state,
                recent_trade: action.payload
            }
        case CANCEL_TO_CREATE_ORDER:
            return {
                ...state,
                errors: null
            }
    }
    return state;

}
